// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dvLOl","content":"NotFound_content__1b9bZ","islandsGroup":"NotFound_islandsGroup__elftl","description":"NotFound_description__GX4XL"};